import axios from "axios";
import { createBrowserHistory } from "history";
import moment from "moment-timezone";
import { message } from "antd";

const history = createBrowserHistory();

function getBackendErrorMessage(error) {
  const data = error.response?.data;
  if (!data) return error.message || "Something went wrong. Please try again.";
  if (typeof data === "string") return data;
  if (data.message) return data.message;
  if (data.error) return typeof data.error === "string" ? data.error : data.error?.message || "Something went wrong. Please try again.";
  return "Something went wrong. Please try again.";
}

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: "application/json",
    Authorization: `Bearer ${localStorage.getItem("pillvery_token")}`,
  },
});

/** Merge portal flags into relative request URLs (never send both). */
function setPortalQueryParam(url, mode) {
  const q = url.indexOf("?");
  const path = q === -1 ? url : url.slice(0, q);
  const queryString = q === -1 ? "" : url.slice(q + 1);
  const params = new URLSearchParams(queryString);
  if (mode === "supplier") {
    params.delete("from_admin");
    params.set("from_supplier", "true");
  } else {
    params.delete("from_supplier");
    params.set("from_admin", "true");
  }
  const qs = params.toString();
  return qs ? `${path}?${qs}` : path;
}

// Role 1 (supplier): from_supplier=true — other roles: from_admin=true
axiosInstance.interceptors.request.use(
  (config) => {
    let user;
    try {
      user = JSON.parse(localStorage.getItem("user") || "{}");
    } catch (_) {
      user = {};
    }

    if (user?.role === 1) {
      config.url = setPortalQueryParam(config.url, "supplier");
    } else {
      config.url = setPortalQueryParam(config.url, "admin");
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 403) {
      // history.push("/signin");
      // localStorage.removeItem("pillvery_token");
      // localStorage.removeItem("user");
      // window.location.reload(true);
      const errorMsg = getBackendErrorMessage(error);
      message.error(errorMsg);
    } else {
      const errorMsg = getBackendErrorMessage(error);
      message.error(errorMsg);
    }

    throw error;
  }
);

export const formatDate = (date) => {
  try {
    let dateObj = date ? new Date(date) : new Date();
    return moment(dateObj).tz("Asia/Amman").format("YYYY-MM-DD");
  } catch (err) {
    console.error(err);
    return moment(new Date()).tz("Asia/Amman").format("YYYY-MM-DD");
  }
};

export const formatDateTime = (date) => {
  return moment(date || Date.now()).tz("Asia/Amman").format("YYYY-MM-DD HH:mm:ss");
};

export { axiosInstance };
